import { useAppSelector } from "../app/hooks";
import { selectIsAnyRtkQueryRequestPending } from "../apiSelectors";

export function useGlobalFetching() {
  return useAppSelector(selectIsAnyRtkQueryRequestPending);
}
